import { createReducer, on } from '@ngrx/store';
import { initialQuotaState } from './quota.state';
import * as QuotaActions from './quota.actions';

export const quotaReducer = createReducer(
  initialQuotaState,

  on(QuotaActions.loadQuotaSummary, (state) => ({
    ...state,
    loading: true,
    error: null
  })),

  on(QuotaActions.loadQuotaSummarySuccess, (state, { quotas }) => ({
    ...state,
    quotas,
    summary: quotas.map(q => ({
      meatTypeName: q.meatType?.nameRu || '',
      totalLimitTons: q.totalLimitVolume / 1000
    })),
    loading: false,
    loaded: true,
    error: null
  })),

  on(QuotaActions.loadQuotaSummaryFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  }))
);
